/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { LABEL_DECIMALS as a, MIN_RATIO as s } from "./constants.mjs";
const h = (e) => {
  const t = e.toString().split(".");
  return t.length === 1 ? `${t[0]}` : `${t[0]}.${t[1].substr(0, a)}`;
}, l = (e, t, r) => {
  const n = Math.abs((t - e) / 100);
  return Math.abs((r - e) / n);
}, $ = (e, t, r, n) => {
  const c = Math.max(r, 0.01), u = 100 / c * 100;
  e.current && t.current && (e.current.style.width = n ? "100%" : `${c}%`, t.current.style.width = n ? "100%" : `${u}%`, e.current.style.height = n ? `${c}%` : "100%", t.current.style.height = n ? `${u}%` : "100%");
}, g = (e, t, r) => Math.max((r - e) / (t - e), s);
export {
  l as calculatePercentage,
  g as calculateRatio,
  h as truncateNumber,
  $ as updateProgress
};
